import axios, { AxiosError } from "axios";

export const transformErrorResponse = (error: any) => {
  if (axios.isAxiosError(error)) {
    // Provjera postoji li `response` i `data` unutar greške
    const res = error as AxiosError; // Tipiziramo grešku kao AxiosError

    var defaultError =
      "Dogodila se greška! Molimo Vas da kontaktirate administratora.";

    if (res.response && res.response.data) {
      // `response.data` postoji

      var result: any = error.response?.data;

      if (typeof result !== "object") {
        return defaultError;
      }

      // Backend vraća greške kao niz { code, description }, pojedinačni { code, description }
      // ili, kod validacije modela, kao ProblemDetails s rječnikom errors { polje: [poruke] }.
      if (Array.isArray(result.errors)) {
        return result.errors[0]?.description ?? defaultError;
      }

      if (hasProperty(result, "errors") && result.errors && typeof result.errors === "object") {
        const firstMessages = Object.values(result.errors)[0];
        const firstMessage = Array.isArray(firstMessages) ? firstMessages[0] : firstMessages;
        return firstMessage ? `${firstMessage}` : defaultError;
      }

      return result.description ?? result.message ?? defaultError;
    } else {
      return defaultError;
    }
  } else {
         
    // Ovo je neka druga greška
    console.error("Greška:", error);

  }
};

const hasProperty = (error: any, prop: string): boolean => {
  return prop in error;
};

/**
 * Vraća opis backend greške za zadani kod (npr. "TenantOibExists"),
 * ili null ako greška ne odgovara tom kodu. Koristi se za prikaz
 * poruke na odgovarajućem polju forme.
 */
export const getApiErrorByCode = (error: any, code: string): string | null => {
  const backendError = error?.response?.data?.errors?.find(
    (e: any) => e.code === code
  );
  return backendError ? backendError.description ?? null : null;
};
